import React from "react";

const Telephone = ({
  placeholder,
  name,
  className,
  validation,
  onBlur,
  onKeyPress,
  phoneStyle,
  value,
  id,
  onChange,
  disabled,
  maxlength,
  validationMsg,
  onInput,
  ...props
}) => {
  return (
    <>
      <input
        type="tel"
        name={name}
        className={className}
        placeholder={placeholder}
        ref={validation}
        onChange={onChange}
        disabled={disabled}
        onBlur={onBlur}
        onKeyPress={onKeyPress}
        style={phoneStyle}
        defaultValue={value}
        id={id}
        maxLength={maxlength}
        onInput={(e) => {
          if (onInput) {
            onInput(e);
          } else {
            e.target.value = e.target.value.replace(/\D/g, ""); // block non numeric values
          }
        }}
        {...props}
      />
       {validationMsg && (
        <>
          <span className="error_msg">{validationMsg}</span>
        </>
      )}
    </>
  );
};
export default Telephone;
